import type { ReactNode } from 'react'
import { useSession } from '@/lib/auth-client'

export function SignedIn({ children }: { children: ReactNode }) {
  const { data: session, isPending } = useSession()

  if (isPending) return null
  if (!session) return null

  return <>{children}</>
}
